<mat-form-field class="gt-xs:pr-3 flex-auto" [class.field-ic-attention]="includeTooltip()" [floatLabel]="'always'">
  <mat-label
    >{{ "NEW_PASSWORD_LABEL" | translate }}
    @if (includeTooltip()) {
      <ic-attention class="-mt-3 inline-flex" color="warn" icon="error">
        {{ "PASSWORD_POLICY_DESCRIPTION" | translate }}
      </ic-attention>
    }
  </mat-label>
  <input
    class="form-control"
    matInput
    type="password"
    [formControlName]="FormKeys.NEW_PASSWORD"
    (change)="changed.emit()"
  />

  @if (controlHasError(FormKeys.NEW_PASSWORD)) {
    <mat-error>
      @if (controlHasError(FormKeys.NEW_PASSWORD, ValidationKeys.REQUIRED)) {
        {{ "ERROR_PASSWORD_REQUIRED" | translate }}
      }
      @if (controlHasError(FormKeys.NEW_PASSWORD, ValidationKeys.STRONG_PASSWORD)) {
        {{ "ERROR_PASSWORD_TOO_WEAK" | translate }}
      }
    </mat-error>
  }
</mat-form-field>

<mat-form-field class="gt-xs:pr-3 flex-auto" [floatLabel]="'always'">
  <mat-label>{{ "NEW_PASSWORD_CONFIRMATION_LABEL" | translate }}</mat-label>
  <input
    class="form-control"
    matInput
    type="password"
    [formControlName]="FormKeys.NEW_PASSWORD_CONFIRMATION"
    (change)="changed.emit()"
  />

  @if (controlHasError(FormKeys.NEW_PASSWORD_CONFIRMATION)) {
    <mat-error>
      {{ "ERROR_PASSWORD_REQUIRED" | translate }}
    </mat-error>
  }
</mat-form-field>

@if (formGroupHasError(ValidationKeys.PASSWORDS_DONT_MATCH)) {
  <div class="mb-4">
    <mat-error>
      <fuse-alert appearance="outline" dismissible="false" type="error">
        {{ "ERROR_PASSWORD_CONFIRMATION" | translate }}
      </fuse-alert>
    </mat-error>
  </div>
}
